<app-header
  [search]="true"
  [enableBack]="false"
>
  <div title>
    {{ 'vee.title' | translate }}
  </div>
</app-header>

<div class="p-6">
  <form [formGroup]="searchForm">
    <app-card>
      <div class="flex gap-4">
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'common.name' | translate }}</label>
            <input type="search" formControlName="name" appInput autofocus [placeholder]="'common.name' | translate">
          </app-input-group>
        </div>
      </div>
      <div>
        <button appButton (click)="table.search(); storeSearch();">{{ 'common.search' | translate }}</button>
      </div>
    </app-card>
  </form>

  <app-table
    #table
    [config]="tableConfig"
    [(selectedElements)]="selectedElements"
  ></app-table>
</div>
